module.exports = __webpack_public_path__ + "static/Apartmani-Mima-Sokobanja-15-4bd523a0b9c1616562dc4b5885feeb05.jpg";